<template>
    <div class="wrapper">
        <q-spinner
            color="primary"
            size="5em"
        />
    </div>
</template>

<style lang="scss" scoped>
.wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>
